import React, { PropsWithChildren, useRef } from 'react'

import { Tooltip } from '@ui/components/Tooltip'

import { useTextOverflow } from './useTextOverflow'

import styles from './Truncate.module.scss'

export const Truncate: React.FC<PropsWithChildren> = ({ children }) => {
  const ref = useRef<HTMLSpanElement>(null)
  const isOverflowing = useTextOverflow(ref)
  const isTooltipDisabled = !isOverflowing

  return (
    <Tooltip content={children} disabled={isTooltipDisabled}>
      <span ref={ref} className={styles.truncateWrapper}>
        {children}
      </span>
    </Tooltip>
  )
}
